import React, { Component, Fragment } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./AccountStyles";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { accountHomeViewActions, accountActions } from "../_actions";
import Loading from "../components/Loading";
import moment from "moment";
import PopupWrapper from "../components/PopupWrapper";
import TariffData from "../components/TariffData";
import AccountSubheader from "../components/AccountSubheader";
import { withCookies } from "react-cookie";
import AccountBackButton from "../components/AccountBackButton";

class AccountHomeViewTariff extends Component {
  constructor(props) {
    super(props);

    const user = JSON.parse(localStorage.getItem("user"));
    const level = props.match.params.level;
    if (level == "infocare") {
      user.user_id = user.dependant_user_id;
    }

    this.props.dispatch(accountHomeViewActions.getTariff(user));
    this.props.dispatch(accountActions.getEnergyDetail(user));
  }

  submit = (values) => {};

  render() {
    const props = this.props;

    const {
      handleSubmit,
      account: { accountFetchingDetail, accountDetail },
      accountHomeView: { fetchingDetail, detail },
    } = props;

    let defaultStandingCharge = (
      <div className={css(styles.unitsWarning)}>
        <img src={"/icons/AlertIcon.svg"} alt="" />
        <p className={css([styles.microcopy, styles.unitsWarningMicrocopy])}>
          You do not have a standing charge set
        </p>
      </div>
    );
    if (detail.standing_charge) {
      defaultStandingCharge = `£${detail.standing_charge.prices[0].toFixed(
        2
      )} per day`;
    } else if (detail.used_tariff && detail.used_tariff.standing_charge) {
      defaultStandingCharge = `£${detail.used_tariff.standing_charge.prices[0].toFixed(
        2
      )} per day`;
    }

    // {detail.standing_charge ||
    //   detail.used_tariff.standing_charge
    //     ? detail.standing_charge.prices[0].toFixed(2)
    //     : detail.used_tariff.standing_charge.prices[0].toFixed(
    //         2
    //       )}{" "}
    return (
      <div className={css(styles.container)}>
        <PopupWrapper />

        <header className={css(styles.header)}>
          <div className={css(styles.titleWrapper)}>
            <img
              src={"/icons/AccountIconLarge.svg"}
              className={css(styles.accountIcon)}
              alt=""
            />
            <h1 className={css(styles.title)}>Account</h1>
          </div>
          <AccountBackButton />
        </header>
        <main className={css(styles.mainContainer)}>
          <AccountSubheader
            backHref={`/account/${this.props.match.params.level}/`}
            backLabel={this.props.match.params.level}
            title="Tariff"
          />
          {accountFetchingDetail && <Loading />}

          {!accountFetchingDetail &&
            accountDetail[0] && (
              <Fragment>
                <form onSubmit={handleSubmit(this.submit)}>
                  {!fetchingDetail && detail && (
                    <div>
                      <div className={css(styles.whiteBox)}>
                        <div className={css(styles.dataSection)}>
                          {detail.tariffs_msg && (
                            <div className={css(styles.unitsWarning)}>
                              <img src={"/icons/AlertIcon.svg"} alt="" />
                              <p
                                className={css([
                                  styles.microcopy,
                                  styles.unitsWarningMicrocopy,
                                ])}
                              >
                                {detail.tariffs_msg}
                              </p>
                            </div>
                          )}
                          <div className={css(styles.twoColumn)}>
                            <h4 className={css(styles.headerTitle)}>
                              Your standing charge
                            </h4>
                            <div className={css(styles.editWrapper)}>
                              <a
                                href={`/account/${this.props.match.params.level}/tariff/standing-charge`}
                                className={css(styles.link)}
                              >
                                <img
                                  src={"/icons/pencil.svg"}
                                  className={css(styles.linkIcon)}
                                  alt=""
                                />
                                Edit
                              </a>
                            </div>
                          </div>
                          <p className={css(styles.paragraph)}>
                            {defaultStandingCharge}
                          </p>
                        </div>
                        <div className={css(styles.dataSection)}>
                          <div className={css(styles.twoColumn)}>
                            <h3 className={css(styles.headerTitle)}>
                              Electricity Rates (£/kWh)
                            </h3>
                            <a
                              href="/account/tariff/info"
                              className={css(styles.link)}
                            >
                              How do tariffs work?
                            </a>
                          </div>

                          <TariffData
                            data={detail.import}
                            used_tariff={
                              detail.used_tariff && detail.used_tariff.import
                            }
                            level={this.props.match.params.level}
                            title="Unit Price"
                            rate="import"
                          />
                          <hr className={css(styles.divide)} />

                          <div className={css(styles.unitsWarning)}>
                            <img src={"/icons/AlertIcon.svg"} alt="" />
                            <p
                              className={css([
                                styles.microcopy,
                                styles.unitsWarningMicrocopy,
                              ])}
                            >
                              For Solar PV use only (leave blank if you don't
                              have Solar PV)
                            </p>
                          </div>

                          <TariffData
                            data={detail.export}
                            used_tariff={
                              detail.used_tariff
                                ? detail.used_tariff.export
                                : null
                            }
                            level={this.props.match.params.level}
                            title="Export Rates"
                            rate="export"
                          />

                          <div className={css(styles.gap)}></div>

                          <TariffData
                            data={detail.generation}
                            used_tariff={
                              detail.used_tariff
                                ? detail.used_tariff.generation
                                : null
                            }
                            level={this.props.match.params.level}
                            title="Generation Rates"
                            rate="generation"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </form>
              </Fragment>
            )}
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let initialValues = {};

  return {
    initialValues,
    ...state,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "accountHomeViewTariff",
    destroyOnUnmount: false,
    enableReinitialize: true,
  })(withCookies(AccountHomeViewTariff))
);
